import { StyleContext } from 'utils/context/StyleContextProvider';
import { useContext } from 'react';
import { CarrotArrowIcon as CarrotArrow } from '@viome/vnxt-nucleus';
import classNames from 'classnames';
import ConditionalWrapper from 'utils/ConditionalWrapper';
import Link from 'next/link';
import styles from './Breadcrumb.module.scss';

export default function Breadcrumb({ items, settings = {} }) {
    const parentStyles = useContext(StyleContext),
        hrefFn = (item) => {
            if (item.url) {
                return item.url;
            }
            if (item.title === 'The Viome Blog') {
                return `/blog`;
            }
            if (item.slug) {
                return `/blog/category/${item.slug}`;
            }
            return '/';
        };

    return (
        <section
            className={classNames(
                settings?.hideMobile && styles.hideMobile,
                styles.breadcrumb,
                parentStyles?.breadcrumb,
                'pb-3 lg:pb-4',
                'my-12 md:mb-10 lg:mt-8',
            )}
            aria-label="breadcrumbs"
        >
            <ol className={classNames('flex', 'gap-x-15')}>
                {items.map((item, index) => (
                    <li
                        className={classNames(
                            'flex',
                            'items-center',
                            'gap-x-15',
                        )}
                        key={item.title}
                    >
                        <p>
                            <ConditionalWrapper
                                condition={
                                    item.slug ||
                                    item.title === 'The Viome Blog' ||
                                    item.url
                                }
                                wrapper={(nodeChildData) => (
                                    <Link href={hrefFn(item)}>
                                        {nodeChildData}
                                    </Link>
                                )}
                            >
                                {item.title}
                            </ConditionalWrapper>
                        </p>
                        {index !== items.length - 1 && <CarrotArrow />}
                    </li>
                ))}
            </ol>
        </section>
    );
}
